const WIDGET_KEY = 'erp-home-widgets'
const FAVORITE_KEY = 'erp-home-favorites'
const HOME_VIEW_KEY = 'erp-home-view-mode'
const RECENT_KEY = 'erp-home-recent-menus'

export const DEFAULT_WIDGET_ORDER = ['welcome', 'inventoryKpi', 'kpiCards', 'shortcuts', 'todo', 'alerts', 'charts']

export const WIDGET_META = {
  welcome: { title: '欢迎区', roles: [] },
  inventoryKpi: { title: '库存 KPI', roles: ['inventory'] },
  kpiCards: { title: '待办统计', roles: [] },
  shortcuts: { title: '快捷入口', roles: [] },
  todo: { title: '待审列表', roles: [] },
  alerts: { title: '预警条', roles: [] },
  charts: { title: '趋势图表', roles: ['inventory', 'sale'] }
}

export const DEFAULT_SHORTCUTS = [
  { key: 'inventoryOtherIn', title: '其他入库', menuUrl: 'inventory/otherIn', perm: 'inventory:otherIn:save', icon: '入' },
  { key: 'inventoryOtherOut', title: '其他出库', menuUrl: 'inventory/otherOut', perm: 'inventory:otherOut:save', icon: '出' },
  { key: 'inventoryQty', title: '库存查询', menuUrl: 'inventory/quantitySearch', perm: 'quantity:search:list', icon: '查' },
  { key: 'salesOrder', title: '销售订单', menuUrl: 'sale/salesOrder', perm: 'sale:salesOrder:save', icon: '销' },
  { key: 'purchaseRequisition', title: '采购请购', menuUrl: 'purchase/purchaseRequisition', perm: 'purchase:purchaseRequisition:save', icon: '购' },
  { key: 'productionOrder', title: '生产工单', menuUrl: 'production/productionOrder', perm: 'production:productionOrder:save', icon: '产' }
]

const PATHS = {
  'inventory/inventoryQuantity': '/inventory/quantitySearch',
  'inventory/warning': '/inventory/warning',
  'inventory/dashboard': '/inventory/dashboard',
  'modules/inventory/dashboard': '/inventory/dashboard'
}

export function menuPath(menuUrl) {
  if (!menuUrl) return ''
  if (PATHS[menuUrl]) return PATHS[menuUrl]
  return '/' + String(menuUrl).replace(/^\//, '')
}

export function getWidgetConfig() {
  try {
    const parsed = JSON.parse(localStorage.getItem(WIDGET_KEY) || 'null')
    const order = parsed && Array.isArray(parsed.order) && parsed.order.length ? parsed.order.slice() : DEFAULT_WIDGET_ORDER.slice()
    DEFAULT_WIDGET_ORDER.forEach(k => { if (order.indexOf(k) === -1) order.push(k) })
    return { order, hidden: parsed && Array.isArray(parsed.hidden) ? parsed.hidden : [] }
  } catch (e) {
    return { order: DEFAULT_WIDGET_ORDER.slice(), hidden: [] }
  }
}

export function saveWidgetConfig(config) {
  localStorage.setItem(WIDGET_KEY, JSON.stringify({ order: config.order || DEFAULT_WIDGET_ORDER.slice(), hidden: config.hidden || [] }))
}

export function getFavoriteShortcuts() {
  try {
    const list = JSON.parse(localStorage.getItem(FAVORITE_KEY) || '[]')
    return Array.isArray(list) ? list : []
  } catch (e) { return [] }
}

export function saveFavoriteShortcuts(keys) {
  localStorage.setItem(FAVORITE_KEY, JSON.stringify(keys || []))
}

export function resolveVisibleWidgets(config, roleFlags) {
  const hidden = new Set(config.hidden || [])
  return (config.order || DEFAULT_WIDGET_ORDER).filter(key => {
    if (hidden.has(key)) return false
    const meta = WIDGET_META[key]
    if (!meta || !meta.roles || !meta.roles.length) return true
    return meta.roles.some(r => roleFlags[r])
  })
}

export function getHomeViewMode() {
  return localStorage.getItem(HOME_VIEW_KEY) === 'flow' ? 'flow' : 'workbench'
}

export function saveHomeViewMode(mode) {
  localStorage.setItem(HOME_VIEW_KEY, mode === 'flow' ? 'flow' : 'workbench')
}

export function recordRecentMenu(menuUrl, title) {
  if (!menuUrl) return
  let list = []
  try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]') } catch (e) { list = [] }
  list = [{ menuUrl, title: title || menuUrl }].concat(list.filter(i => i.menuUrl !== menuUrl)).slice(0, 8)
  localStorage.setItem(RECENT_KEY, JSON.stringify(list))
}

export function getRecentMenus() {
  try {
    const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]')
    return Array.isArray(list) ? list : []
  } catch (e) { return [] }
}
